import {
  Answer,
  AnswerCreateDTO,
  FillInTheBlankOption,
  FillInTheBlankOptionCreateDTO,
  OrderingItem,
  OrderingItemCreateDTO,
  PositionalAnswerCreateDTO,
  PositionalItem,
  QuestionCreateDTO,
  QuizAnswer,
  QuizAnswerCreateDTO,
} from '@/models/Answer';

const adapterAnswer = ({
  id,
  text,
  mediaFile,
  altText,
}: Answer): AnswerCreateDTO => ({
  id,
  text: text ?? null,
  mediaFile: mediaFile?.url ?? null,
  altText: altText ?? null,
});

export const adapterAnswersWithValidPositions = <
  T extends Answer & { validPositions: number[] },
>(
  items: T[],
) =>
  items.map(item => ({
    ...adapterAnswer(item),
    validPositions: item.validPositions ?? [],
  }));

export const adapterQuizAnswers = (
  answers: QuizAnswer[],
): QuizAnswerCreateDTO[] =>
  answers.map(({ isCorrect, ...answer }) => ({
    ...adapterAnswer(answer),
    isCorrect,
  }));

export const adapterOrderingAnswers = (
  items: OrderingItem[],
): OrderingItemCreateDTO[] => adapterAnswersWithValidPositions(items);

export const adapterPositionalAnswers = (
  items: PositionalItem[],
): PositionalAnswerCreateDTO[] => adapterAnswersWithValidPositions(items);

export const adapterPositionalQuestions = (
  items: PositionalItem[],
): QuestionCreateDTO[] => items.map(adapterAnswer);

export const adapterFillInTheBlankOptions = (
  options: FillInTheBlankOption[],
): FillInTheBlankOptionCreateDTO[] => adapterAnswersWithValidPositions(options);
